// extracted by mini-css-extract-plugin
export default {"logout":"style_logout__xUDBX","modalBody":"style_modalBody__MDB3m","l2":"style_l2__SlMxk","accountSettingsSection":"style_accountSettingsSection__mG4an"};